export const ENDPOINTS = {
  searchTemplates: (searchTerm) => `/templates?name=${searchTerm}`,
  deleteTemplate: (id) => `/templates/${id}`
};
